import { render, staticRenderFns } from "./LoadingItem.vue?vue&type=template&id=0077ae3c&scoped=true"
import script from "./LoadingItem.vue?vue&type=script&lang=js"
export * from "./LoadingItem.vue?vue&type=script&lang=js"
import style0 from "./LoadingItem.vue?vue&type=style&index=0&id=0077ae3c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0077ae3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0077ae3c')) {
      api.createRecord('0077ae3c', component.options)
    } else {
      api.reload('0077ae3c', component.options)
    }
    module.hot.accept("./LoadingItem.vue?vue&type=template&id=0077ae3c&scoped=true", function () {
      api.rerender('0077ae3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Goods/LoadingItem.vue"
export default component.exports